<template>
  <b-modal
    id="modal-update-position"
    ref="updatePositionModal"
    :title="'order_positions_editing' | i18n"
    :ok-title="'save' | i18n"
    :cancel-title="'abort' | i18n"
    :ok-disabled="!isPositionFormValid"
    ok-variant="primary"
    cancel-variant="outline-primary"
    button-size="sm"
    @hidden="resetPositionModal"
    @ok="updatePosition"
  >
    <b-form-group
      id="position-articlenumber"
      :label="'article_number_short' | i18n"
      label-for="position-articlenumber-input"
    >
      <b-form-input
        id="position-articlenumber-input"
        v-model="positionForm.articleNumber"
        :value="positionForm.articleNumber"
        type="text"
        trim
      />
    </b-form-group>
    <b-form-group
      id="position-quantity"
      :label="'amount' | i18n"
      label-for="position-quantity-input"
    >
      <b-form-input
        id="position-quantity-input"
        v-model="positionForm.quantity"
        :value="positionForm.quantity"
        type="number"
        trim
      />
    </b-form-group>
  </b-modal>
</template>

<script>
import {OrderMixin, NotificationMixin} from '../../mixins';

export default {
  name: 'UpdatePosition',
  mixins: [OrderMixin, NotificationMixin],
  data: function () {
    return {
      positionForm: {
        articleNumber: null,
        quantity: null
      }
    };
  },
  computed: {
    isPositionFormValid: function () {
      return this.positionForm.articleNumber && this.positionForm.quantity;
    }
  },
  methods: {
    resetPositionModal() {
      this.positionForm.id = null;
      this.positionForm.articleNumber = null;
      this.positionForm.quantity = null;
    },
    async updatePosition(bvModalEvt) {
      try {
        bvModalEvt.preventDefault();
        const {id, orderId, ...position} = this.positionForm;
        await this.orderService.updateOrderPosition({orderId: orderId, positionId: id, position});
        this.$refs.updatePositionModal.hide();
        this.showNotification({
          type: 'success',
          title: 'Position Bearbeiten',
          message: 'Position erfolgreich bearbeitet.'
        });
        this.$emit('updated');
      } catch (err) {
        this.showNotification({type: 'error', title: 'Position Bearbeiten', message: err.message});
      }
    },
    show(position) {
      this.positionForm = {...position};
      this.$refs.updatePositionModal.show();
    }
  }
};
</script>

<style scoped>

</style>
